<template>
  <div ref="home_wrap" class="home_wrap">
    <!-- 后台轮播图 -->

    <van-swipe :autoplay="3000" class="swiper-container">
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/1.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/2.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/3.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/4.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/5.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/6.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/7.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
      <van-swipe-item>
        <router-link :to="'#'">
          <img src="../../assets/images/banner/8.png" style="border-radius: 10px" />
        </router-link>
      </van-swipe-item>
    </van-swipe>
    <!-- Jackpot -->
    <!-- 滚动通知 -->
    <div class="notice_root">
      <img class="notice_icon" src="../../assets/images/index/notice.gif" />
      <div class="container">
        <van-notice-bar class="notice_content" background="none" :scrollable="notice_bar_scroll">
          <template #default>
            <div v-html="notice" />
          </template>
        </van-notice-bar>
      </div>
      <div @click="$router.push('/support?tab=2')">
        <mail class="mailIcon" />
      </div>
    </div>

    <!--      PC大屏幕加背景-->
    <div class="sand_bot">
      <div id="nav" class="nav_box">
        <van-tabs v-model="nav_active" class="van-tabs__wrap--scrollable" :sticky="false" :swipeable="true"
          :swipe-threshold="2" line-width="1.5rem" :background="'transparent'" :color="'#fff0bb'" @change="tabChange">
          <van-tab>
            <template #title>
              <div class="nav_title">
                <img v-if="nav_active == 0" class="nav_img" src="../../assets/images/category/HOTa.png" />
                <img v-else class="nav_img" src="../../assets/images/category/HOT.png" />
                <span class="ppl">Popular</span>
              </div>
            </template>
          </van-tab>
          <van-tab>
            <template #title>
              <div class="nav_title">
                <img v-if="nav_active == 1" class="nav_img" src="../../assets/images/category/Slotsa.png" />
                <img v-else class="nav_img" src="../../assets/images/category/Slots.png" />
                <span class="ppl">Slots</span>
              </div>
            </template>
          </van-tab>
          <van-tab>
            <template #title>
              <div class="nav_title">
                <img v-if="nav_active == 2" class="nav_img" src="../../assets/images/category/Pescariaa.png" />
                <img v-else class="nav_img" src="../../assets/images/category/Pescaria.png" />
                <span class="ppl">Pescaria</span>
              </div>
            </template>
          </van-tab>
          <van-tab>
            <template #title>
              <div class="nav_title">
                <img v-if="nav_active == 3" class="nav_img" src="../../assets/images/category/Blockchaina.png" />
                <img v-else class="nav_img" src="../../assets/images/category/Blockchain.png" />
                <span class="ppl">Blockchain</span>
              </div>
            </template>
          </van-tab>
          <van-tab>
            <template #title>
              <div class="nav_title">
                <img v-if="nav_active == 4" class="nav_img" src="../../assets/images/category/sporta.png" />
                <img v-else class="nav_img" src="../../assets/images/category/sport.png" />
                <span class="ppl">Esporte</span>
              </div>
            </template>
          </van-tab>
          <!-- <van-tab>
            <template #title>
              <div class="nav_title">
                <img
                  v-if="nav_active == 5"
                  class="nav_img"
                  src="../../assets/images/category/CPa.png"
                />
                <img
                  v-else
                  class="nav_img"
                  src="../../assets/images/category/CP.png"
                />
                <span class="ppl">CP</span>
              </div>
            </template>
          </van-tab> -->
        </van-tabs>
      </div>
      <div class="jackpot">
        <div class="jnumber">
          <countTo :start-val="startVal" :end-val="endVal" :duration="3000" :decimals="2" :decimal="','"
            :separator="'.'" />
        </div>
      </div>
      <!-- 游戏列表 -->
      <div v-for="(game, idx) in all_game_list" :id="'game' + idx" :key="idx" class="new-list">
        <div v-for="(game_t, tidx) in game" v-show="tidx.indexOf('Img') < 0" :key="tidx">
          <div :ref="tidx" class="game_title">
            <img :src="game[tidx + 'Img']" alt="" />{{ tidx }}
          </div>
          <div class="game-list">
            <div v-for="(item, index) in game_t" v-show="index < step_show" :key="index" class="game-item" @click="
              playGame(
                item.game_id,
                item.origin,
                item.id,
                item.is_works,
                index
              )
              ">
              <div v-lazy:background-image="item.img" class="innerbox" :class="idx + '_innerbox'">
                <!-- <img v-lazy="item.img" class="bgImg" /> -->
                <img v-if="nav_active == 0 && item.is_works" class="good" src="../../assets/images/common/good.webp"
                  alt="" />
                <img v-if="!item.is_works" src="../../assets/images/common/nowork.png" class="nowork" />
                <div v-if="item.origin != 'CP'" class="game_item_pg_name">
                  {{ item.game_name }}
                </div>
              </div>
              <!-- <div v-if="item.origin != 'CP'" class="game_item_name">
                {{ item.game_name }}
              </div> -->
            </div>
          </div>
          <div v-show="game_t.length > step_show" class="show_more" @click="showMore(idx)">
            <div>
              A exibir {{ step_show }} jogos entre {{ game_t.length }} Popular
              jogos
            </div>
            Mostre mais ⇊
          </div>
        </div>
      </div>
    </div>

    <!--弹窗公告1-->
    <div v-show="show_tc" class="popup" @click="show_tc = false">
      <div class="tc_content" @click.t.stop="a = 1">
        <!-- <img src="../../assets/images/logo/logo.png" class="tc_logo" /> -->
        <div class="notice_html" v-html="alter_notice" />
        <img src="../../assets/images/common/close.png" class="close_notice" @click="closeNotice()" />
      </div>
    </div>
    <!-- 兑换码页面 -->
    <div v-show="show_rc" class="popup" @click="show_rc = false">
      <div class="rc_content" @click.t.stop="a = 1">
        <div class="rc_container">
          <div class="rc_body-content">
            <div class="rc_body-content-top">
              <div class="rc_body-content-top-box1">
                <div></div>
                <div>Bônus de novo jogador</div>
                <div></div>
              </div>
              <div style="position: relative;"><van-field class="codeInput" style="padding: 0;" v-model="codeValue"
                  placeholder="Introduza o código de resgate">
                  <template #left-icon>
                    <i class="custom-icon">
                      <svg width="1.5em" height="1.5em" fill="currentColor" aria-hidden="true" focusable="false"
                        style="margin-top: .15rem;">
                        <symbol viewBox="0 0 20.002 14.03" id="input_icon_dhm--svgSprite:all">
                          <g id="input_icon_dhm--svgSprite:all_icon_dl_dhm" transform="translate(-0.992 -3.95)">
                            <path id="input_icon_dhm--svgSprite:all_Union_146" data-name="Union 146"
                              d="M-3910.779,1971.029h-13.41v-14h13.6a.38.38,0,0,1,.349.181.857.857,0,0,1,.141.4.892.892,0,0,1-.1.45.613.613,0,0,1-.361.31.85.85,0,0,0-.589.71.692.692,0,0,0,.11.469.925.925,0,0,0,.48.339.909.909,0,0,1,.4.331,1,1,0,0,1,.159.46.766.766,0,0,1-.11.45.677.677,0,0,1-.389.3.891.891,0,0,0-.521.32.832.832,0,0,0-.057,1,.94.94,0,0,0,.459.372.826.826,0,0,1,.419.339,1.012,1.012,0,0,1,.149.47.892.892,0,0,1-.1.48.823.823,0,0,1-.331.339,1,1,0,0,0-.724.782.8.8,0,0,0,.53.76.789.789,0,0,1,.4.35,1.019,1.019,0,0,1,.169.5.913.913,0,0,1-.1.478.66.66,0,0,1-.36.3.911.911,0,0,0-.52.309.762.762,0,0,0-.2.47.832.832,0,0,0,.14.509,1.176,1.176,0,0,0,.49.419.683.683,0,0,1,.32.35,1.022,1.022,0,0,1,.068.461.865.865,0,0,1-.159.41.378.378,0,0,1-.322.181Zm-2.592-4.36a1.69,1.69,0,0,0,.548-.3,1.38,1.38,0,0,0,.371-.509l0,.069a1.675,1.675,0,0,0,.141-.81,1.284,1.284,0,0,0-.207-.78,1.454,1.454,0,0,0-.491-.439,1.237,1.237,0,0,0,.44-.41,1.183,1.183,0,0,0,.179-.7,1.566,1.566,0,0,0-.12-.619,1.551,1.551,0,0,0-.339-.492,1.521,1.521,0,0,0-.529-.31,1.712,1.712,0,0,0-.652-.119,1.909,1.909,0,0,0-.639.109,1.54,1.54,0,0,0-.521.3,1.576,1.576,0,0,0-.348.479,1.658,1.658,0,0,0-.141.65h1a.671.671,0,0,1,.2-.481.65.65,0,0,1,.47-.169.714.714,0,0,1,.461.169.651.651,0,0,1,.2.51.766.766,0,0,1-.162.48.642.642,0,0,1-.52.2h-.15v.85h.15a.776.776,0,0,1,.559.2.811.811,0,0,1,.19.54.775.775,0,0,1-.2.561.724.724,0,0,1-.52.189.831.831,0,0,1-.28,0,.559.559,0,0,1-.229-.13.6.6,0,0,1-.161-.221.957.957,0,0,1-.07-.31h-1a1.928,1.928,0,0,0,.15.72,1.447,1.447,0,0,0,.378.491,1.357,1.357,0,0,0,.55.28,2.2,2.2,0,0,0,.64.09A2.273,2.273,0,0,0-3913.371,1966.669Zm-4.14-4.279a.737.737,0,0,1,.171.489.7.7,0,0,1-.07.329,1.1,1.1,0,0,1-.21.321l-2,2.331v.89h3.27v-.89l-2.071-.031,1.51-1.74.241-.3a2.291,2.291,0,0,0,.18-.281,1.159,1.159,0,0,0,.11-.3,1.192,1.192,0,0,0,0-.351,1.731,1.731,0,0,0-.12-.659,1.306,1.306,0,0,0-.339-.491,1.618,1.618,0,0,0-.51-.31,2.026,2.026,0,0,0-.66-.11,2,2,0,0,0-.65.109,1.435,1.435,0,0,0-.522.311,1.445,1.445,0,0,0-.35.491,1.759,1.759,0,0,0-.119.66h1a.721.721,0,0,1,.06-.318.475.475,0,0,1,.151-.211.453.453,0,0,1,.21-.119.978.978,0,0,1,.24,0h.042A.616.616,0,0,1-3917.512,1962.39Zm-4.2,4.359h1v-5.34h-1l-1.1.95v1.06l1.1-1Zm-8,4a1.56,1.56,0,0,1-.28-1.07v-4a.912.912,0,0,1,.089-.46.511.511,0,0,1,.37-.21.893.893,0,0,0,.279-.081,1.535,1.535,0,0,0,.361-.27,1.818,1.818,0,0,0,.3-.469,1.8,1.8,0,0,0,.129-.72,1.5,1.5,0,0,0-.319-1,1.215,1.215,0,0,0-.681-.419.728.728,0,0,1-.4-.181.566.566,0,0,1-.13-.43v-3a1.9,1.9,0,0,1,.231-1.07c.16-.22.49-.33,1.04-.37h3.271v14h-3.26a1.3,1.3,0,0,1-.209.017A1.3,1.3,0,0,1-3929.711,1970.75Z"
                              transform="translate(3930.993 -1953.05)"></path>
                          </g>
                        </symbol>
                        <use xlink:href="#input_icon_dhm--svgSprite:all"></use>
                      </svg></i>
                  </template>
                </van-field>
                <span class="paste" @click="paste">Paste</span>
              </div>
              <div class="rc_body-content-top-box3">
                <div>Valor do bônus: <span>1,80- 8.888,00</span></div>
                <p>Lembrete: É necessário um depósito de <span>0 </span>para retirar o lucro obtido!</p>
              </div>
            </div>
            <div class="rc_introduction">
              <span class="rc_introduction-title">Instruções Do Evento:</span>
              <div>
                1.Digite o código de troca para resgatar os prêmios. O dinheiro será creditado ditamente na conta após o
                código ser validado;
                <br>
                2.Um código de troca só pode ser utilizado uma vez e será invalidado após o uso;
                <br>
                3.Utilize o código de troca emitido dentro do período de validade. O código de troca expirado se tornará
                inválido. Durante o período do evento, só pode ser utilizado um código por conta;
                <br>
                4.O bônus concedido neste evento (excluindo o principal) precisa ser apostado 1 (ou seja, auditoria,
                apostas
                ou apostas válidas) e um depósito de 20 para ser retirado, sem limitações de plataforma;
                <br>
                5.O código de troca deve ser utilizada pelo titular da conta. É proibido alugar, usar plug-ins externos,
                robôs, apostar em contas diferentes, brushing mútuo, arbitragem, interface, protocolo, exploração de
                vulnerabilidades, controle de grupo ou outros meios técnicos para participar. Uma vez verificado, a
                plataforma tem o direito de terminar o login do membro, suspender o uso do site pelo membro e confiscar
                prêmios e lucros obtidos indevidamente sem aviso prévio;
                <br>
                6.Ao concordar em participar de este evento, a plataforma assumirá que o membro concorda e cumprirá as
                regras e regulamentos correspondentes. Em caso de divergências de interpretação das normativas, a
                plataforma
                possui o direito de manter a interpretação final deste evento.
                <br>
              </div>
            </div>
            <div class="bottomBlack"></div>
            <div class="rc_btn">
              <van-button class="submitCode" :disabled="isDisabled" @click="submitCode" type="primary">Resgatar
                Bônus</van-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--弹窗公告2-->
    <!-- <div
      v-show="show_tc2 && rechargeConfigList.length"
      class="popup2"
      @click="closeRechargeTip()"
    >
      <div class="tc_content2">
        <img src="../../assets/images/logo/logo.png" class="tc_logo" />
        <div class="tc_head">Bônus Extra De Depósito Inicial</div>
        <table id="tc-table">
          <tr style="color: #111" class="tc_bgw">
            <th>Primeira recarga</th>
            <th>Valor Da Recompensa</th>
          </tr>
          <tr v-for="(item, index) in rechargeConfigList" :key="index">
            <td>≥{{ item.min_money }}</td>
            <td>{{ item.gift_amount }}</td>
          </tr>
        </table>
        <div style="width: 90%; margin: 0.4rem auto">
        </div>

        <img
          src="../../assets/images/common/close.png"
          class="close_recharge_tc"
          @click="closeRechargeTip()"
        />
      </div>
    </div> -->

    <!-- 游戏盒子-->
    <div v-show="show_game_box" id="bigBox" class="game-box">
      <!--    <div class="game-box" id="bigBox" v-show="true">-->
      <!-- <iframe :src="game_url" frameborder="0" id="myiframe"></iframe> -->
      <div class="back_to_desk" @click="beforeCloseGame()">
        <!-- <van-icon name="close" class="close_game_btn" /> -->
        <van-icon name="wap-home-o" class="close_game_btn" />
        <div style="font-size: 0.3rem">Sair</div>
      </div>
    </div>

    <!-- <a
      :href="$store.state.config.download_url"
      target="_blank"
      class="download"
    >
      <img src="../../assets/images/index/download.png" width="100" />
    </a> -->
    <div id="indexbr_box">
      <a v-if="showTop5" class="telegram" @click="$router.push('turnTable')">
        <img src="../../assets/images/Turntable/t.gif" width="100" />
        <div class="icon_box" @click.stop="closeImg('showTop5')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>
      <a v-if="showTop4" class="telegram">
        <img src="../../assets/images/index/whatsapp.png" class="invitation" width="100" style="border-radius: 20px"
          @click.stop="openLink(tglink.group_whatsapp)" />
        <div class="icon_box" @click="closeImg('showTop4')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>
      <a v-if="showTop1" class="telegram">
        <img src="../../assets/images/index/top1.gif" class="invitation" width="100" style="border-radius: 20px"
          @click.stop="$router.push('/activity?tab=1')" />
        <div class="icon_box" @click="closeImg('showTop1')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>

      <a v-if="showTop2" class="telegram" @click="openLink(tglink.group_ins)">
        <img src="../../assets/images/index/instagram_2111463.png" width="100" />
        <div class="icon_box" @click.stop="closeImg('showTop2')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>
      <a v-if="showTop3" class="telegram" @click="openLink(tglink.group_admin_service)">
        <img src="../../assets/images/index/top3.gif" width="100" />
        <div class="icon_box" @click.stop="closeImg('showTop3')">
          <van-icon name="close" class="close_icon" />
        </div>
      </a>
    </div>

    <!--    <img src="../images/na/ftr3.png" @click="goSupport()" class="service"  width="100">-->

    <ft />
  </div>
</template>

<script>
import Vue from "vue";
import mail from "../../components/svg/mail.vue";
import Fetch from "../../utils/fetch";
import { NoticeBar } from "vant";
import ft from "../../components/ft.vue";
import Axios from "axios";
import {
  Swipe,
  SwipeItem,
  Icon,
  Progress,
  Popover,
  Field,
  Tabs,
  Tab,
  Lazyload,
  Button
} from "vant";
import countTo from "vue-count-to";

Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Icon)
  .use(Progress)
  .use(Popover)
  .use(Field)
  .use(NoticeBar)
  .use(Tabs)
  .use(Tab).use(Button)
  .use(Lazyload, {
    lazyComponent: true,
  });

export default {
  name: "Index",
  components: {
    VanSwipe: Swipe,
    VanSwipeItem: SwipeItem,
    ft,
    countTo,
    mail,
  },
  data() {
    return {
      lang: this.$i18n.locale || "zh_cn",
      notice_bar_scroll: false,
      myBaners: [],
      isDisabled: true,
      nav_active: 0,
      show_rc: false,
      show_kefu: true,
      msg_show: false,
      loading: false,
      codeValue: "",
      icon: [],
      data: {
        item1: { show: true },
        item2: { show: true },
        item3: { show: true },
      },
      islogin: false,
      isapp: false,
      tglink: "",
      insLink: "",
      show_tc: false,
      show_tc2: true,
      tc_content: "",
      gameList: [],
      show_game_box: false,
      game_url: "",
      gameType: 0,
      username: null,
      all_game_list: {},
      all_game_list_bak: [],
      keyword: "",
      notice: "",
      alter_notice: "",
      head_image: "",
      level: 0,
      total_bet_amount: 0,
      sub_level_amount: 0,
      group_service: "",
      service: "",
      leftCount: 0,
      secondsUntilNextHour: 0,
      timeStr: "00:00:00",
      time_id: null,
      is_ban: 0,
      evtSource: null,
      category: "slots",
      banners: [],
      showcbl: false,
      avd_img: null,
      avd_url: null,
      startVal: 0,
      endVal: 0,
      step_show: 18,
      max_show_array: [18, 18, 18, 18],
      jtid: null,
      todayInfo: {},
      rechargeConfigList: [],
      userInfo: {},
      send2index: 0,
      scroll: 0,
      showTop1: true,
      showTop2: true,
      showTop3: true,
      showTop4: true,
      showTop5: true
    };
  },
  watch: {
    keyword: function (newn) { },
    codeValue: function (newVal) {
      if (newVal !== '') {
        this.isDisabled = false;
      } else {
        this.isDisabled = true;
      }
    }
  },
  created() {
    this.$bus.$emit("send2ftnav", 0);
    this.$bus.$on("isShowRedemptionCode", (value) => {
      this.show_rc = value;
    });
    //监听左侧菜单传来的事件
    this.$bus.$on("send2index", (idx) => {
      this.tabChange(idx);
      this.send2index = idx;
      window.removeEventListener("scroll", this.scrollToTop);
    });

    //获取通知
    this.getNotice();
    this.isShowTop("showTop1");
    this.isShowTop("showTop2");
    this.isShowTop("showTop3");
    this.isShowTop("showTop4");
    this.isShowTop("showTop5");
  },

  mounted() {
    this.$bus.$emit("send2headshow", false);
    this.getJackpot();
    //this.getBanner();
    this.getAlterNotice();
    this.getUserInfo();
    this.getGameList();
    //设置jackpot定时器
    clearInterval(this.jtid);
    this.jtid = setInterval(() => {
      this.startVal = this.endVal;
      this.endVal = this.endVal + Math.random() * 100;
    }, 10000);
    window.addEventListener("scroll", this.scrollToTop, true);
  },
  destroyed() {
    this.$bus.$emit("send2headshow", true);
    clearInterval(this.time_id);
    clearInterval(this.jtid);
    window.removeEventListener("scroll", this.scrollToTop);
  },
  methods: {
    closeImg(type) {
      this[type] = false;
      localStorage.setItem(type, new Date().getTime());
    },
    openLink(url) {
      console.log(url);
      window.open(url);
    },
    async paste() {
      try {
        const text = await navigator.clipboard.readText();
        // console.log('粘贴成功: ', text);
        this.codeValue = text;
      } catch (err) {
        console.error('无法粘贴: ', err);
      }
    },
    submitCode() {
      Fetch("/box/exchange_code", {
        code: this.codeValue
      }).then((r) => {
        console.log(r);
        if (r.code !== 0) {
          this.$message({
            // title: this.$store.state.config.site_name,
            type: "success",
            message: r.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
          this.show_rc = false;
        } else {
          this.$message({
            // title: this.$store.state.config.site_name,
            type: "error",
            message: r.msg,
            center: true,
            showClose: true,
            offset: 300,
          });
        }
      });
    },
    isShowTop(type) {
      const time = localStorage.getItem(type);
      if (time) {
        const newTime = new Date().getTime();
        if (newTime - time > 3600000) {
          this[type] = true;
        } else {
          this[type] = false;
        }
      }
    },
    scrollToTop() {
      var scrollTop =
        window.scrollY ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (!document.getElementById("nav")) {
        return;
      }
      if (scrollTop >= 200) {
        document.getElementById("nav").classList.add("myFixed");
      } else {
        document.getElementById("nav").classList.remove("myFixed");
      }
      if (scrollTop < 1100) {
        this.nav_active = 0;
      } else if (scrollTop < 1500 && scrollTop >= 1100) {
        this.nav_active = 1;
      } else if (scrollTop < 2400 && scrollTop >= 1500) {
        this.nav_active = 2;
      } else if (scrollTop < 2900 && scrollTop > 2400) {
        this.nav_active = 3;
      } else if (scrollTop >= 2900) {
        this.nav_active = 4;
      }
    },
    onLoad() {
      console.log("图片加载成功啦!!!");
    },
    closeRechargeTip() {
      // console.log(this.username);
      if (this.username) {
        //看一下今天有没有弹过了
        let today = new Date();
        if (localStorage.getItem("date_time") != today.getHours()) {
          localStorage.setItem("date_time", today.getHours());
        }
      }
      this.show_tc2 = false;
    },
    beforeCloseGame() {
      document
        .getElementById("bigBox")
        .removeChild(document.getElementById("myiframe"));
      this.show_game_box = false;
      this.game_url = "";
      //重新获取用户的余额
      this.getUserInfo();
      // Fetch("/box/getTodaybetInfo", {}, false, true).then((r) => {
      //   this.$confirm(
      //     `Você apostou ${r.data.today_bet_amount} e completou ${
      //       r.data.percent
      //     }%, restando ${
      //       100 - r.data.percent
      //     }% para reivindicar bônus de apostas adicionais.`,
      //     {
      //       confirmButtonText: "Continuar o jogo",
      //       cancelButtonText: "Deixe o jogo",
      //       // type: 'warning',
      //       showClose: false,
      //       center: true,
      //     }
      //   )
      //     .then((e) => {
      //       console.log("用户选择了继续游戏...", e);
      //     })
      //     .catch((e) => {
      //       console.log(e);
      //       document
      //         .getElementById("bigBox")
      //         .removeChild(document.getElementById("myiframe"));
      //       this.show_game_box = false;
      //       this.game_url = "";
      //       //重新获取用户的余额
      //       this.getUserInfo();
      //     });
      // });
    },
    showMore(idx) {
      this.step_show += 18;
    },
    getJackpot() {
      Fetch("/index/getJackpotNumber").then((r) => {
        r.data.money = parseFloat(r.data.money);
        this.startVal = r.data.money - 500;
        this.endVal = r.data.money;
      });
      Fetch("/index/getLink").then((r) => {
        // console.log(r.data);
        this.tglink = r.data;
        // this.insLink = r.data[2].value;
        //console.log(this.tglink,+'123'+this.insLink);
      });
    },
    getBanner() {
      //获取后台轮播图
      // Fetch("/index/getBanner").then((response) => {
      //   this.banners = response.data;
      // });
    },
    tabChange(v) {
      this.nav_active = v;
      if (v == 0) {
        this.category = "Popular";
        this.scrollToCard(this.category);
      }
      if (v == 1) {
        this.category = "Slots";
        this.scrollToCard(this.category);
      }
      if (v == 2) {
        this.category = "Pescaria";
        this.scrollToCard(this.category);
      }
      if (v == 3) {
        this.category = "Blockchain";
        this.scrollToCard(this.category);
      }
      if (v == 4) {
        this.category = "Esporte";
        this.scrollToCard(this.category);
      }
      // if (v == 4) this.category = "JDB";
      // if (v == 5) this.category = "CP";
      // this.getGameList(v);
    },
    scrollToCard(refName) {
      // let cardElement = this.$refs[refName][0].offsetTop;
      // let parent = document.getElementById("vier_port");
      // let parentElement = document.getElementById("vier_port").offsetTop;
      let cardElement = this.$refs[refName][0];
      this.scroll = cardElement.offsetTop;
      // console.log(cardElement, parentElement, "123213");
      if (cardElement) {
        // 使用原生的 scrollIntoView 方法来滚动到元素位置
        cardElement.scrollIntoView();
      }
    },
    getAirdrop() {
      Fetch("/airdrop/getAirdrop", {}).then((res) => {
        //console.log(r);
        this.$toast({
          background: "#07c160",
          message: res.msg,
          duration: 5000,
        });
        if (res.code == 1) {
          setTimeout(() => {
            this.getUserInfo();
          }, 2500);
        }
      });
    },
    //获取空投时间和剩余的数量
    AirdropCount() {
      Fetch("/airdrop/getLeftTimeAndCount", {}, {}, false).then((res) => {
        //console.log(res);
        if (res.code == 1) {
          this.secondsUntilNextHour = res.data.secondsUntilNextHour;
          this.leftCount = res.data.leftCount;
          let seconds = this.secondsUntilNextHour;
          this.time_id = null;
          clearInterval(this.time_id);
          this.time_id = setInterval(() => {
            if (seconds <= 0) {
              clearInterval(this.time_id);
              this.AirdropCount();
              return;
            }
            let hours = Math.floor(seconds / 3600);
            let minutes = Math.floor((seconds % 3600) / 60);
            let remainingSeconds = seconds % 60;
            this.timeStr = `${String(hours).padStart(2, "0")}:${String(
              minutes
            ).padStart(2, "0")}:${String(remainingSeconds).padStart(2, "0")}`;
            //console.log(this.timeStr)
            seconds--;
          }, 1000);
        }
      });
    },
    getUserInfo() {
      Fetch("/user/is_login").then((r) => {
        if (r.data) {
          this.userInfo = r.data;
          this.username = r.data.username;
          this.userbalance = r.data.money;
          this.head_image = r.data.avatar;
          this.level = r.data.level;
          this.total_bet_amount = r.data.total_bet_amount;
          this.sub_level_amount = r.data.sub_level_amount;
          this.is_ban = r.data.is_rob;
          this.$parent.changeBalance(r.data.money);
        } else {
          localStorage.removeItem("user_balance");
        }
      });
    },
    getGameList(v) {
      let url = "/Game/getPopularGames";
      this.category = "";
      // this.nav_active = v;
      // if (v == 0) {
      //   url = "/game/getPopularGames";
      //   this.category = "";
      // }
      // if (v == "2") {
      //   url = "/game/getPescariaGames";
      //   this.category = "";
      // }
      // if (v == "3") {
      //   url = "/game/getBlockchainGames";
      //   this.category = "";
      // }
      Fetch(url, {
        type: this.category,
      }).then((res) => {
        // if (this.category == "PG") {
        //   this.all_game_list = {
        //     PG: {
        //       slots: [
        //         {
        //           id: 125,
        //           game_id: "PG",
        //           game_name: "PG Slots",
        //           origin: "URL",
        //           sort: 3000,
        //           img: "https://img.carnaval88.com/img/pgSlots.png",
        //           type: 1,
        //           is_works: 1,
        //         },
        //         {
        //           id: 124,
        //           game_id: "PP",
        //           game_name: "PP Slots",
        //           origin: "URL",
        //           sort: 3000,
        //           img: "https://img.carnaval88.com/img/ppSlots.png",
        //           type: 1,
        //           is_works: 1,
        //         },
        //         {
        //           id: 123,
        //           game_id: "TADA",
        //           game_name: "JILI Slots",
        //           origin: "URL",
        //           sort: 3000,
        //           img: "https://img.carnaval88.com/img/jiliSlots.png",
        //           type: 1,
        //           is_works: 1,
        //         },
        //         {
        //           id: 122,
        //           game_id: "JDB",
        //           game_name: "JDB Slots",
        //           origin: "URL",
        //           sort: 3000,
        //           img: "https://img.carnaval88.com/img/jdbSlots.png",
        //           type: 1,
        //           is_works: 1,
        //         },
        //       ],
        //     },
        //   };
        // } else {
        //   let _this = this;
        //   if (res.data.length && this.nav_active !== 0) {
        //     this.all_game_list = {
        //       PP: {
        //         slots: res.data,
        //       },
        //     };
        //   } else {
        //     this.all_game_list = res.data;
        //     this.all_game_list_bak = res.data;
        //     console.log(this.all_game_list);
        //   }
        //   console.log(this.all_game_list, "数据");
        // }
        this.all_game_list = res.data;
        this.all_game_list_bak = res.data;
      });
    },
    getPGHtml(game_id) {
      // console.log(this.userInfo);return null;
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          let _this = this;
          return new Promise((resolve, reject) => {
            Axios.post("https://test.carnaval88.com/api/demo/getPGHtml", {
              game_id: game_id,
              user: _this.userInfo,
            })
              .then(function (response) {
                resolve(response.data);
              })
              .catch(function (error) {
                reject(error);
              });
          });
        }
      }

      return new Promise((resolve) => {
        Fetch(
          "/demo/getPGHtml2",
          { game_id: game_id, token: localStorage.getItem("token") },
          {},
          true
        ).then((res) => {
          resolve(res);
        });
      });
    },
    getJDBtoken(gameId) {
      return new Promise((resolve) => {
        Fetch("/jdb_game/jdbtoken", { id: gameId }, false, false).then(
          (res) => {
            resolve(res);
          }
        );
      });
    },
    getCPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/cp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getPPUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/pp/getGameUrl", { game_id: gameId }, false, false).then(
          (res) => {
            if (res.code == 1) resolve(res);
          }
        );
      });
    },
    getJiliUrl(gameId) {
      return new Promise((resolve) => {
        Fetch("/jili/game_url", { id: gameId }, false, false).then((res) => {
          if (res.code == 1) resolve(res);
          //resolve("https://www.google.com");
        });
      });
    },
    closeNotice() {
      localStorage.setItem("notify", this.alter_notice);
      this.show_tc = false;
      // window.open(this.tglink.group_admin_service);
      // this.$confirm(
      //   `Entre no grupo do Telegram para participar de atividades e receber recompensas`,
      //   {
      //     distinguishCancelAndClose: true,
      //     confirmButtonText: "Participe agora",
      //     cancelButtonText: "Mais tarde",
      //     showClose: false,
      //     center: true,
      //   }
      // )
      //   .then(() => {
      //     window.open(this.tglink.group_admin_service);
      //   })
      //   .catch((action) => {
      //     // 关闭
      //     if (action == "cancel") {
      //       window.open(this.tglink.group_admin_service);
      //     }
      //   });
    },
    getAlterNotice() {
      Fetch("/user/alter_notice", {}).then((res) => {
        this.alter_notice = res.data;
        if (localStorage.getItem("notify") == res.data) {
          this.show_tc = false;
        } else {
          this.show_tc = true;
        }
      });
      Fetch("/recharge/rechargeConfigList", {}).then((res) => {
        //console.log(res);
        if (res.data.is_open) {
          this.rechargeConfigList = res.data.config_list;
          let today = new Date();
          if (localStorage.getItem("date_time") != today.getHours()) {
            localStorage.setItem("date_time", today.getHours());
            this.show_tc2 = true;
          } else {
            this.show_tc2 = false;
          }
        }
      });
    },
    getNotice() {
      Fetch("/user/notice", {}).then((res) => {
        this.notice = res.data;
        this.notice_bar_scroll = true;
      });
    },
    async playGame(gameId, origin, jdb_game_id, is_work, index) {
      if (origin == "URL") {
        return this.$router.push({
          path: "subgame",
          query: { gameId: gameId },
        });
      }
      if (this.userInfo.remark) {
        if (
          this.userInfo.remark.indexOf("模拟") != -1 ||
          this.userInfo.remark.indexOf("测试") != -1
        ) {
          if (origin != "PG") {
            return this.$message({
              message: "Contas simuladas só podem jogar jogos PG",
              type: "error",
            });
          }
        }
      }

      if (!this.username) {
        this.$parent.login();
        return;
      } else {
        //被后台禁止游戏了
        if (this.is_ban) {
          this.$toast({
            background: "#07c160",
            message:
              "Sua conta atual ainda não ativou as funções do jogo, entre em contato com seu gerente",
            duration: 5000,
          });
          return;
        }
        if (!is_work) {
          this.$toast({
            background: "#07c160",
            message: "Este jogo está em manutençãoe",
            duration: 5000,
          });
          return;
        }
        if (this.userbalance < 0.4) {
          return this.$router.push("recharge");
        }
      }
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
      console.log(index, "点击");
      // 添加本地缓存
      let localGames = localStorage.getItem("local_game_list");
      if (!localGames) {
        let json_obj = { PG: [], JDB: [], TADA: [] };
        localStorage.setItem("local_game_list", JSON.stringify(json_obj));
        localGames = localStorage.getItem("local_game_list");
      }

      localGames = JSON.parse(localGames);
      //console.log(localGames.PG);
      //return false;
      //存入本地最近游戏游戏列表中
      if (localGames[origin] && localGames[origin].indexOf(jdb_game_id) == -1) {
        localGames[origin].push(jdb_game_id);
        localStorage.setItem("local_game_list", JSON.stringify(localGames));
      }

      //玩游戏前 需要先判断一下是PG的游戏还是JDB的游戏
      if (origin == "JDB") {
        //先获取一下游戏的链接
        let resp = await this.getJDBtoken(jdb_game_id);
        return this.launchJDB(resp.data);
      }

      if (origin == "TADA") {
        //先获取一下游戏的链接
        let resp = await this.getJiliUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "CP") {
        //先获取一下游戏的链接
        let resp = await this.getCPUrl(gameId);
        return this.launchJDB(resp.data);
      }
      //CP游戏
      if (origin == "PP") {
        //先获取一下游戏的链接
        let resp = await this.getPPUrl(gameId);
        return this.launchJDB(resp.data);
      }

      //PG
      if (origin == "PG") {
        this.show_game_box = true;
        var iframe = document.createElement("iframe");
        iframe.setAttribute("height", "100%");
        iframe.setAttribute("width", "100%");
        iframe.setAttribute("frameborder", "0");
        iframe.setAttribute("scrolling", "no");
        iframe.setAttribute("id", "myiframe");
        let l = localStorage.getItem("lang");
        let game_l = "pt";
        if (l == "pt_br") game_l = "pt";
        if (l == "en_us") game_l = "en";
        if (l == "zh_cn") game_l = "zh";
        this.game_url = await this.getPGHtml(gameId);
        if (this.game_url.data) {
          this.launchJDB(this.game_url.data.url);
        } else {
          iframe.addEventListener("load", function () {
            console.log("iframe loaded!");
          });
          var bigBox = document.getElementById("bigBox");
          bigBox.appendChild(iframe);
          iframe.contentWindow.document.write(this.game_url);
        }
      }
    },
    launchJDB(url) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.setAttribute("allowfullscreen", "true");
      iframe.setAttribute("webkitallowfullscreen", "true");
      iframe.setAttribute("mozallowfullscreen", "true");
      iframe.setAttribute("src", url);
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
    },

    createIframe(content) {
      this.show_game_box = true;
      var iframe = document.createElement("iframe");
      iframe.setAttribute("height", "100%");
      iframe.setAttribute("width", "100%");
      iframe.setAttribute("frameborder", "0");
      iframe.setAttribute("scrolling", "no");
      iframe.setAttribute("id", "myiframe");
      iframe.addEventListener("load", function () {
        console.log("iframe loaded!");
      });
      var bigBox = document.getElementById("bigBox");
      bigBox.appendChild(iframe);
      iframe.contentWindow.document.write(
        "<script>alert(1); window.location.href = " + content + ""
      );
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/variables.less";
@headerHeight: 1.2rem;
@mainColor: #005dfe;
@mainBgColor: #95846f;

.svgStyle {
  color: @textcolor1;
}

.popup {
  position: fixed;
  top: 0rem;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.popup2 {
  position: fixed;
  // max-width:@maxWidth;
  top: -1.3rem;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 6;
  display: flex;
  align-items: center;
  justify-content: center;
}

.myFixed {
  position: fixed;
  top: 1.2rem;
  z-index: 2;
  width: 100%;
  max-width: @maxWidth;
}

.rc_content {
  width: 95%;
  max-width: @maxWidth*0.95;
  // max-width: 12rem;
  //height: 6rem;
  // overflow-x: hidden;
  // overflow-y: auto;
  position: absolute;
  background: @activityColor;
  padding: 0 0.3rem;
  box-sizing: border-box;
  border-radius: 0.35rem;
  top: -1.3rem;
  // background-image: url("../../assets/images/common/bg1.png");
  position: relative;
  padding-top: 0.2rem;

  .rc_container {
    .rc_body-content {
      display: flex;
      flex-direction: column;
      height: 16rem;
      // justify-content: space-between;
      width: 100%;
      overflow-y: auto;

      .rc_body-content-top {
        display: flex;
        flex-direction: column;
        gap: .2rem;
        margin-top: 0;
        overflow: initial;
        padding: .2rem;
        background-color: @secondary-color;
        border-radius: .14rem .14rem .1rem .1rem;
        font-size: .22rem;

        .rc_body-content-top-box1 {
          align-items: center;
          display: flex;
          height: 1rem;
          justify-content: center;
          margin: 0 .4rem;
          position: relative;
        }

        .rc_body-content-top-box3 {
          color: @textcolor1;
          // display: flex;
          font-size: .3rem;

          div {
            span {
              color: @textcolor4 !important;
            }
          }

          p {
            span {
              color: #fff !important;
            }
          }
        }
      }

      .rc_introduction {
        // display: flex;
        margin-top: .3rem;
        overflow: initial;
        padding: .2rem;
        background-color: @secondary-color;
        border-radius: .14rem .14rem .1rem .1rem;
        font-size: .32rem;

        .rc_introduction-title {
          font-weight: 700;
        }

        div {
          font-size: .32rem;
          color: @textcolor1;
          line-height: .5rem;
        }
      }

      .rc_btn {
        bottom: 0;
        left: 0;
        padding-top: .2rem;
        position: absolute;
        width: 100%;
        text-align: center;
        margin: .5rem auto 0;
        margin-bottom: .3rem;
        // background-color: @activityColor;
      }

      .bottomBlack {
        padding-top: 2rem;
      }
    }
  }

}

/* 针对Webkit浏览器，如Chrome、Safari */
::-webkit-scrollbar {
  width: 0;
  height: 0;
  // background: transparent;
  /* 如果需要的话 */
}

/* 针对Firefox */
* {
  scrollbar-width: none;
  /* Firefox */
}

/* 针对IE和Edge */
body {
  -ms-overflow-style: none;
  /* IE and Edge */
}

.custom-icon path {
  fill: @textcolor1;
}

.rc_body-content-top-box1>div:first-child {
  width: 1.12rem;
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRmADAABXRUJQVlA4TFMDAAAvecAdEG+gppEU6O5a/JsjVHRoeG0ICIr8H01R2zZQyh/U7ucgTTPTto1RlEnfQRl/jcQC8P+n5VwYxdJzSx6GDLGumiUGcmzbdtsGU7ggHFrl0FGQA8vkQFecghO0uJRzmIDMMil8lVZmhSFoCBoT8ID/3/0ObUT/HUmSJCQ1OgSDemqo8QtBEHTWkkKtrByKOjo6+iWq1zOWuroal1fGz6SkDg7k6/RUcnlp4/HRzloJK4e21rO2K5fmeCw0Y28aDosH5jgpPRzyx0G65j7WN/Gyjg8V47ELwSoxX048ecuXPPWWL1nEfLnhLV+2Lx56GT95zVew6jVfaeIzX+mav+fI03ri8TnSkW9f+XpOEp/PkTWJr3wVzn3lq3Ak5ssJZr4cTjz6Yo04fhtOjqztOaHl6zOAurV11mn5ijIwst5T6TopX12gGuLaly8WUL1YQN+XL15ix9Twle6LdtzMqWCUUWf7oh0C1XNjQpgcti8iAGiYLqrGZGOyL7oQNWqjnvOb7IsaJs6XgXotJ8KQ7IvX+GrMLDCNfv4DN2RfvMTQmG6ISQzMMSbYvogwMuKQUUOV7Ysob6YriLAt20mL5YvXGIho5oQYPorDIm5IvqihKu8oDGvZFdkiXJN80YU4bWdUUDeinYS4YfmigolzcSEG9i5Em8MEzRe14i0laqI5Hn8Jsc3zRQWYaP6IUKilOARueL5oh7BXnemLt0Um4zgUX7qh+OJ9LGtK/kacVygu3jF88RoltRS3LiooqRu1LyyIeJej9oUWtS+0qH2hRe0LLWpfaFH7gkpKH6t9oYXhi/dxSY0yluOSuvO75z9yfNEqVt4+tgq1x/KF67hO8IUWtS/UaH2hRusLNVpfaFH7QovaF1rUvqDCzhdhz2d9xMuYsOfTwukjX4Q9n3pDsseEPV8HYc/XQdjzqaTkMWHP50LPl9oX3I+Qx/8FX2j/t5fXVcl/G9Keb+x2LsDa820UG23Pd22kPd+1qX2hGI9z1L7QjhW+0I/tH/GZr+fER77UvtCOFb7gjK2+YOfL6gt2vtS+0I4VvvAwDoKUmC8nAmK+3KDny+uez/JFj9RWveYrZT9HFL7gj8nPETeI+XLDY77W/D5HfnJ9Yaez5s0XYwA=);
  background-size: 100% 100%;
}

.rc_body-content-top-box1>div:nth-child(2) {
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRsYFAABXRUJQVlA4TLkFAAAv98AdABfwBarxF5AkR/y/smD+YwnjCASS9tceIiJCd5wATiBVuQveP4GznxW0AMGUqclk7CCi/5DcthEkdc1otrOTPaUd7RccJqASWAUOYFD7eJADCN3+u+jrvv4JIvoPyQHbsE3WERET+USRyhcsP/152/d9DzqmNlVNN7Xff+j6j36O9i5FtUu41tDpv6H7bZkrPeNAnvIiLPPf2bZpMD1e5a7Vz8fSXkrr0ku8dC+17bB6EZaDSBMpL/i1vXuqE9OhcvXh8WyUJuA1hznMMVZrWGRhejQp+w4269RjalKCUbWq6vyV4l7gi2OYl3sPp0Va75SD6VAj4KDN1+CAAGrceuaqVh3Uv5vEa2+HZTt0RvHfkrBCWQNAaZvtcUHvwslXhrm29jkUVF667WzQWQ8qea0eENsQliKwcL4IiG247HXoDP+qOlP3wm1rOa+P012Ekzqb2ZwJKsN4gc6YKT9fN3M2lp17vnq2CKDKwSjorEvz4i/0B+Zs6fAa2iROzdIzaUNzZnaOGeqMGvVs21/ZthDZnkAzDEjS03YFAuWpc2PpQp35gcnZHpPGe+a7xwidYXeyqIbnDNVCZHYunXkhSVeaiuesQJyh92x73ZO0hzbJbrbDsYO+4nW6mJo92y/AviEkypx8ZbexuaI2b19xsqenU2eSaag09aLBlr7p5HgQearj8pWHWyfJ0jzmeM/lK43SnqY7zdk9oufylWj8oXH8zYNK7bDjN+grcFCyWH8HbdLTXBlqA3wlTqAnWYwRy8/+fB+YK9MpbONC8q/Y5qAwV3Qq+gqHRtMp1DvZtvTY5SvR8V1keUjtkRXZvQ19pVPr2aKCOSunDNtiZZngKxKWSD03ITdzFjXqDE7NajyZswciHqCfMpNk/XQD5grMU5063/2xJxbmi/WGuMccgY0nOdsnk+hc2ZBhTlM+Ccap0d4QWyJoHIKAkvSp0d5g89obCn46TJX2BihNos1vsq/sn2hv2E7cOuO0xjfYOTtrXHuDRJHNEQ+q7LdLMUciCSRP095g89IZRlihjfWGPcBXriUxeZB7PlhvWGvogfmSxpz1lRMspDeYd9ilM68lCUbjDYnqRF9p7Xu+Mumo0BtwrhydOmK+pFHejTegNyQw29BG4WlZX3HQJsnNgux2QF+RX56WLW/SG2b8AKj/3Buyw3uDGn4HMnH+a2qfZHcz8KKl9yXXSnjDumCOFSqr+OklIEfC0Xr2ld1m1B654PKV/N4wD0hvmFhCG+eLA+gNafnKke5FgU68IQHmSL4wdW2MN3xA0CJcyRGdF20HaIptLe9pZow3INy+4kzP+ukB6w02L1+RwneBE3t6zm5faXkvrw5nzqjy+fAVTueIA8gVIXMFnldo7A0QG4EiwqjSxuYKLA4LB1taPkdUOW+YuhRpuOdCjpgRc3YB7InCle/fg0buEXgsNICldI6cw3kD2tLqYIiUz5FzOG+wedECWZDNEbaMcOvsKeRIUoZ7ZH9APM1q3CwiuV2wan3ojJi5kCM6ubYP4Cb5737/55RqW3rpLHwh3ebK4waC+5JwNkdcO/F/v8O4dcZgaYUcmYP1hq/5iqUllyMeMVcyZ7l11oVrNPYGBvCskiNmIFeSTLt0FukrlRzRSe+Ra77AliqeNmhvWGssHE1O+6kr30AuuhdyxBa9Rwb6ChF1ruTIuPQGaS0/Xx733tCpV+gLbxiKvsKtlN126w0FZ8jnjCxLE5ZsjiS58pKeGJsiVXIEeQPpiVRwBj9n957IaZWuOGc3ZXq8M9uW5Yqwc9YonyPJ80V6YthSa0lPS3OFmjM4mamaI+TzdSZ6WjVHbj2xMxP/J0c4T2ywmv8lR4TyxBDZ02o5cumJIFMq5QhdxhwRjhj5C/1xnojWUMqRCNITqVOjp5QjZNvSC7iwN2S5IpwnQkElP730RJZYj/+SIw/picTfm14DAA==);
  background-size: 100% 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  // margin: 0 -.02rem;
  font-size: .4rem;
  // font-weight: 700;
  // border: none;


  color: #fff;
}

.rc_body-content-top-box1>div:nth-child(3) {
  width: 1.12rem;
  height: 1rem;
  background-position: 0 0;
  background-image: url(data:image/webp;base64,UklGRn4CAABXRUJQVlA4THICAAAvecAdEE+gppEU6D5MUWIA/0oosUEgaeP6d/4Jsm2Wm1zkMvdnmIK2bZjwZ9NtLD6jBcCsb1Ik5MoBekZ/uR3A0ba3bYMUkbN8A8U3EGA/j2fkAK6709eeC/jmlghQ+FPWiP47cNs2khxsivHeu0aUN9wWRWaxWX1/41TXtaM6ZCIqlS292prPPc1mY7XvIerdoyuPjalk6eg292hr1FhaT7aLMvVoaTnVrtLeUu+2SvsuD6q4XHOI3WUaVHG5lBD7jUayDuMMsZOrfRq9ci8Skq/sSXn3nV9fFswxNrmt+KaqOtWuk+j4xkF29hvLUOczJF/Jt2XUouy3CltVNczusmdzrN3eZbcVtgbNkXaTbJvD7LI2GNuoBpEvS3eQfFmXkHxZhbVbSL6sC0i+rIdA89U2UHtDyHxtEuHydZeRc6TLFbPztIqz38ifI2fF2alidpYNwouixfGizsbxYrChvBheC8gLUSgvWLC80FBe1OULyIvTKpgXfr6gvDitkLwYtVheuDaUF8xYXiiYF8pIXmg0L6D52vhzJJoXuHzd5ZrZ+SfzQoQZyYvQ2UmVsxO652swL3D5SlhGvmEZ2eWqfP3NvFBm7J6v4D1fGbnnazQvsIxs3XxF88LNF5QXp9WfyYua/Q+454sieaEsUF6w/s97/t/MC2X+rXu+iAiUF6xQXuh/zAvV/3LPd20oL1ihvBCB8oKxvFD+Vbxw8wXkxVBAXuy/8+vLAsWLXaJzHRcgXjQ0qjVDePFARS0jeWGf5QHgxZ6MWgB48WhpGTVHTDWW1pPnSI2SpWPQHNmYypZep86RyQrixaUpMivGPhARAQ==);
  background-size: 100% 100%;
}

.tc_content {
  width: 95%;
  max-width: @maxWidth*0.95;
  // max-width: 12rem;
  //height: 6rem;
  // overflow-x: hidden;
  // overflow-y: auto;
  position: absolute;
  background: @secondary-color;
  padding: 0 0.3rem;
  box-sizing: border-box;
  border-radius: 0.35rem;
  top: -1.3rem;
  // background-image: url("../../assets/images/common/bg1.png");
  position: relative;
  padding-top: 0.2rem;
}

.tc_content2 {
  width: 90%;
  max-width: @maxWidth*0.8;
  // max-width: 12rem;
  background: @third-color;
  border-radius: 0.3rem;
  position: relative;
}

.game_title {
  color: #fff;
  font-size: 0.4rem;
  margin: 0.4rem auto 0.6rem 0.5rem;
  display: flex;
  align-items: center;

  img {
    width: 0.7rem;
    margin-right: 0.2rem;
  }
}

#tc-table {
  border: none;
  margin: auto;
  text-align: center;
  width: 90%;
  background-color: @secondary-color;
  padding: 0.2rem;
  color: #fafafa;

  th {
    height: 0.8rem;
    border: 1px solid rgba(255, 255, 255, 0.2);
  }

  td {
    width: 50%;
    height: 0.8rem;
    border-bottom: 1px solid rgba(255, 255, 255, 0.2);
    // border-right: 1px solid rgba(255,255,255,0.2);
  }
}

.tc_head {
  padding: 0.3rem 0 0.4rem 0;
  text-align: center;
  font-weight: 700;
  font-size: larger;
  color: #fff;
}

.tc_bgw {
  padding: 0;
  background-color: @secondary-color;
  color: #fff !important;
  border-width: 0;
}

.paste {
  position: absolute;
  top: .2rem;
  right: .2rem;
  font-size: .26rem;
  color: @textcolor4;
}

.tcbtn {
  background: @anttextcolor;
  color: @primary-color;
  padding: 0.2rem;
  border-radius: 0.1rem;
  float: right;
  margin-top: -0.7rem;
}

.close_notice {
  position: absolute;
  width: 0.7rem;
  height: 0.7rem;
  // top: 0.2rem;
  // right: 0.2rem;
  left: 50%;
  bottom: -1rem;
  margin-left: -0.35rem;
}

.close_recharge_tc {
  position: absolute;
  width: 0.7rem;
  height: 0.7rem;
  // top: 0.2rem;
  // right: 0.2rem;
  left: 50%;
  margin-left: -0.35rem;
  bottom: -1rem;
}

.tc_logo {
  width: 80%;
  display: block;
  margin: 0 auto;
}

.fz3 {
  color: #000;
  font-size: 0.3rem;
  margin-left: 0.1rem;
  font-weight: 700;
}

.jackpot {
  width: 95%;
  margin: 0.2rem auto;
  height: 2.7rem;
  background-image: url("../../assets/images/index/jk1.png");
  background-size: 100% 100%;
  overflow: hidden;
  // background-color: rgba(0,0,0,0.5);
  border-radius: 0.2rem;
}

.jnumber {
  display: flex;
  align-items: center;
  height: 1rem;
  justify-content: center;
  font-size: 0.6rem;
  color: #ffff6b;
  font-weight: 600;
  margin-top: .4rem;
  margin-bottom: 0.2rem;
  font-family: cursive !important;
}

.jgame {
  width: 50%;
  display: flex;
  margin: 0 auto;
  justify-content: space-around;
}

.jimg {
  height: 1rem;
  width: 1rem;
}

.mytest_svg {
  width: 0.8rem;
  height: 0.66rem;
}

.ppl {
  display: block;
  height: 0.7rem;
  line-height: 0.7rem;
  text-align: center;
  font-size: 0.3rem;
}

.nav_img {
  display: block;
  // height: 1rem;
  margin: 0 auto;
  font-size: 0.8rem;
  height: 0.66rem;
  // width: 0.8rem;
}

.nav_title {
  // height: 2rem;
  // display: flex;
  // border-bottom: 1px solid #e5e5e5;
}

.van-dialog {
  // background: #FFF;
  border: 1px solid #e14ce1;
}

.codeInput {
  font-size: 11px;
  border-radius: 7px;
  height: 30px;
  line-height: 30px;
  background-color: transparent !important;
  padding-right: 41px !important;
  border-color: @textcolor1 !important;
  box-shadow: none !important;
  border: 0.01rem solid;
  padding-left: .3rem !important;
}

/deep/ .van-field__label {
  width: auto;
  // margin-left: .3rem;
}

/deep/ .van-tabs__wrap--scrollable {
  /* 自定义样式 */
  color: @anttextcolor;
  background: transparent;
  border-width: 1.5rem;
}

/deep/ .van-cell::after {
  content: none;
}

/deep/ .van-tabs__wrap--scrollable .van-tab {
  color: @textcolorf;
}

/deep/ .van-tabs__wrap--scrollable .van-tab--active {
  color: @anttextcolor;
}

/deep/ .van-field__control {
  color: #fff;
}

/deep/ .van-button--default {
  // background: #ffdc83 !important;;
  color: #ffdc83;
  background: #a541ff !important;
  // background: linear-gradient(90deg, #3FBBFE 0%, #A541FF 100%);
}

.category-item .slot_name {
  width: 100%;
  text-align: center;
  height: 0.7rem !important;
  line-height: 0.7rem !important;
  font-weight: 700;
  font-size: 0.35rem;
  color: #e14ce1;
}

.category-item .s_active {
  color: #fff;
}

.sec-title {
  color: #fff;
  font-size: 0.35rem;
  line-height: 0.6rem;
  //margin-left: 0.25rem;
}

.svg_box {
  width: 0.8rem;
  height: 0.66rem;
}

.c-sm-des {
  width: 95%;
  margin: 0.2rem auto 0 auto;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  height: 1rem;

  img {
    width: 1.6rem;
  }

  span {
    display: block;
    font-size: 0.46rem;
    color: #fff;
    font-weight: bold;
  }
}

.sec-img {
  width: 0.4rem;
}

.ci-des {
  display: block;
  color: #e14ce1;
  font-size: 0.26rem;
}

.cdactive {
  color: #ffdc83 !important;
}

.ci-img {
  display: block;
  width: 40px;
  height: 40px;
}

.category-item {
  width: 18%;
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 0.1rem 0;
  margin: 0 auto;
  border-radius: 0.2rem;
  border: 1px solid #895db3;
  background-image: linear-gradient(180deg,
      rgba(146, 30, 146, 1) 0,
      rgba(146, 30, 146, 1) 0,
      rgba(85, 9, 85, 1) 100%,
      rgba(85, 9, 85, 1) 100%);
}

.cot {
  text-align: center;
  color: gold;
  margin-top: -10px;
}

.baoxiang {
  width: 55px;
  display: block;
  margin: 0 auto;
  //margin-top: -10px;
}

.daily-gift2 {
  position: absolute;
  width: 65px;
  height: 75px;
  bottom: 195px;
  right: 10px;
  z-index: 2;
  background-color: #0d7319c7;
  border-radius: 15px;
  text-align: center;
}

.daily-gift {
  position: absolute;
  width: 65px;
  bottom: 55px;
  left: 10px;
  z-index: 2;
  animation: my-btn 2s ease-in infinite;
  background-color: #0d73196a;
  border-radius: 50%;
}

.top-right-div {
  padding: 0 5px;

  height: 50px;
  //width: 120px;
  //flex-wrap: wrap;
}

.goReachrge {
  display: block;
  // height: 40px;
  display: flex;
  align-items: center;
  padding: 5px 8px;
  //background-image: linear-gradient(to right, #a60092, #6011d0) !important;
  color: white;
  border-radius: 15px;
  font-size: 0.4rem;
  background: #224131;
}

.head_image {
  height: 30px;
  margin-left: 10px;
  border-radius: 50%;
  border: 1px solid #fff;
}

.recharge-wrap {
  height: 25px;
  margin-left: 10px;
  border-radius: 0.24rem;
  box-shadow: 0 0 0 0 #dd234b;
  // width: 0.8rem;
  // height: 0.56rem;
  animation: WalletButtonBlink-JUR1h 2.5s ease 0s infinite normal none running;
}

.recharge-img {
  // width: 30px;
  height: 100%;
  // margin-left: 10px;
}

@keyframes WalletButtonBlink-JUR1h {

  10%,
  90% {
    transform: translate3d(-2px, 0, 0);
  }

  0% {
    transform: scale(1);
  }

  70% {
    box-shadow: 0 0 0 0.2rem rgba(255, 49, 65, 0);
    transform: scale(1);
  }

  to {
    box-shadow: 0 0 rgba(255, 49, 65, 0);
    transform: scale(1);
  }
}

#myiframe {
  height: 100%;
  width: 100%;
  background: #3e4b58;
  position: absolute;
}

.game-box {
  position: fixed;
  width: 100%;
  max-width: @maxWidth;
  top: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10;
}

.back_to_desk {
  position: absolute;
  top: 0;
  left: 0;
  //background: rgba(0, 0, 0, 0.5);
  z-index: 999999;
  height: 1rem;
  width: 1rem;
  // display: flex;
  border-radius: 100%;
  background: rgba(0, 0, 0, 0.3);
  border: 0.02rem solid #fff;
  color: #fff;
  font-size: 0.22rem;
  text-align: center;
  padding: 0.2rem 0.2rem;
}

.close_game_btn {
  font-size: 0.8rem;
  border-radius: 50%;
  color: #fff;
}

.game_name {
  width: 100%;
  text-align: center;
  position: absolute;
  height: 0.8rem;
  line-height: 0.8rem;
  bottom: 0.3rem;
  color: #fff;
  font-size: 0.45rem;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
  //background-color: rgba(0, 0, 0,0.5);
}

.gameimg-wrap {
  width: 100%;
  height: 0;
  padding-bottom: 100%;
  position: relative;
}

.game-img {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 0.2rem;
}

.game-name {
  font-size: 0.3rem;
  color: #c7c7c7;
  text-align: center;
}

.game-name_logo {
  background-image: linear-gradient(90deg,
      rgba(138, 53, 128, 1) 0,
      rgba(138, 53, 128, 1) 0,
      rgba(111, 7, 184, 1) 100%,
      rgba(111, 7, 184, 1) 100%);
  border-radius: 50%;
  height: 0.7rem;
  width: 0.7rem;
  border: 1px solid #ac69a8;
  position: absolute;
  top: 74%;
  z-index: 8;
  margin-top: 11px;
}

.game-name_logo img {
  margin: 5px 5%;
  width: 90%;
}

.game-name_text {
  background-image: linear-gradient(90deg,
      rgba(138, 53, 128, 1) 0,
      rgba(138, 53, 128, 1) 0,
      rgba(111, 7, 184, 1) 100%,
      rgba(111, 7, 184, 1) 100%);
  border-radius: 12px;
  height: 0.6rem;
  line-height: 0.6rem;
  border: 1px solid #ac69a8;
  width: 90%;
  position: relative;
  margin-left: 10%;
  margin-top: 5px;
  padding-left: 0.5rem;
}

.search-wrap {
  //background: rgba(250, 223, 0,0.8);
  border: 1px solid #f8b600;
  height: 0.8rem;
  width: 95%;
  margin: 0.3rem auto 0 auto;
  border-radius: 0.2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

// .simg {
//   font-size: 0.6rem;
//   margin-right: 0.2rem;
//   color: @popupcolor;
// }

.input-keyword {
  width: 70%;
  height: 100%;
  color: #fff;
  font-size: 0.32rem;
  float: left;
  text-indent: 10px;
  background: none;
  border: none;

  input {
    background: none;
    border: none;
    outline: none;
  }
}

/deep/ input.van-field__control::placeholder {
  color: @textcolor1;
  font-size: .24rem;
}

.input-keyword::placeholder {
  color: #f8b600;
}

.game-list {
  width: 95%;
  margin: 0.2rem auto 0rem auto;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-start;
}

.game-item {
  width: 33.3%;
  //height: 3.5rem;
  margin-bottom: 0.3rem;
  overflow: hidden;
  box-sizing: border-box;
  position: relative;
}

.nowork {
  width: 2.8rem;
  height: 3.7rem;
  position: relative;
  z-index: 1;
  background: rgba(0, 0, 0, 0.34);
  margin: 0 auto;
}

.innerbox {
  width: 2.8rem;
  height: 3.7rem;
  position: relative;
  overflow: hidden;
  background-size: 100% 100%;
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 0.25rem;
  box-sizing: border-box;
  // border: 1px solid #feb705;
  margin: 0 auto;

  // .bgImg {
  //   width: 2.8rem;
  //   height: 3.7rem;
  // }
  .good {
    width: 0.6rem;
  }
}

.new-list {
  position: relative;
  margin-bottom: 0.3rem;
}

.xbanner {
  width: 100%;
  box-sizing: border-box;

  img {
    width: 100%;
    border-radius: 0.2rem;
    border: 0.06rem solid #ba955b;
    box-sizing: border-box;
  }
}

.show_more {
  color: @anttextcolor;
  width: 95%;
  margin: 0 auto;
  border-radius: 0.2rem;
  text-align: center;
  font-size: 0.35rem;

  div {
    height: 0.5rem;
    line-height: 0.5rem;
    color: @textcolor3;
  }
}

.item-btn-left {
  float: left;
  padding: 8px 0;
  font-size: 0.35rem;
  //color: #AA976F;
  color: #a7a3a3;
}

.des-right-top {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  color: #ffffff;
}

.des-right-mid {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  //color: #826B47;
  color: #ffffff;
}

.des-right-btm {
  height: 20px;
  line-height: 20px;
  margin: 0 !important;
  font-size: 0.4rem;
  //font-weight: 700;
  //color: #826B47;
  color: #ffffff;
}

.des-left-btm {
  font-size: 0.4rem;
  color: #ad9d89;
}

.des-left-top {
  height: 30px;
  line-height: 30px;
  color: #e64d20;
  font-size: 0.7rem;
  font-weight: 700;
}

.game_item_name {
  //width: 2rem;
  margin-top: 0.1rem;
  color: #fff;
  font-size: 0.3rem;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-weight: 700;
}

.game_item_pg_name {
  color: #fff;
  text-align: center;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  //margin: 0 auto;
  width: 100%;
  font-size: 0.35rem;
  font-weight: 500;
  left: 0;
  bottom: 0;
  height: 0.7rem;
  // line-height: 0.5rem;
}

.des-left {
  width: 36%;
  height: 100%;
  //background: #07c160;
  text-align: center;
  float: left;
}

.des-right {
  width: 64%;
  height: 100%;
  //background: #07c160;
  //text-align: left;
  text-indent: 0.5rem;
  float: left;
}

.item_div4 {
  position: relative;
}

.progress-number {
  position: absolute;
  color: #947f59;
  left: 72%;
  height: 10px;
  top: -1px;
  margin: 0 !important;
  font-size: 12px;
  font-weight: 700;
}

.item-des {
  height: 60px;
  //background: #8d8d8f;
  width: 100%;
  margin: 0 !important;
}

/deep/ .van-cell {
  padding: 15px 26px;
}



.progress-div {
  width: 70%;
  height: 10px;
  border-radius: 5px;
  background: #e2dcd4;
  position: relative;
}

.progress-in {
  height: 10px;
  border-radius: 5px;
  position: absolute;
  left: 0;
  top: 0;
  background: #3ba00e;
  width: 50%;
  margin: 0 !important;
}

.home_wrap {
  // position: relative;
  width: 100%;
  min-height: 100vh;
  position: relative;
  padding-top: @headerHeight;
  background-image: url("../../assets/images/common/bg.png");
  background-color: @secondary-color;
  background-size: 2rem;
}

.top-right-menu {
  position: fixed;
  left: 0;
}

.search_box {
  width: 90%;
  height: 32px;
  background-color: #f6f6f6;
  border-radius: 17px;
  border: solid 1px #1989fa;
  margin: 8px auto;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 0 10px 0 14px;

  .search_inp {
    flex: 1;
    margin: 0 8px;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
    height: 20px;
  }
}

/deep/ .el-carousel__mask {
  background: transparent !important;
}

.swiper-container {
  width: 95%;
  border-radius: 0.3rem;
  margin: 0 auto 0 auto;
  overflow: hidden;
  padding-top: 0.2rem;

  .van-swipe-item {
    overflow: hidden;
  }

  a {
    float: left;
    width: 100%;
    height: 100%;
  }

  img {
    border-radius: 0;
    // margin-left: 2%;
    height: 100%;
    width: 100%;
  }
}

.work_box {
  display: flex;
  flex-wrap: wrap;
  justify-content: start;
  border-radius: 0.2rem;
  width: 98%;
  margin: 0.1rem auto 0.3rem auto;
}

.notice_root {
  width: 95%;
  height: 0.8rem;
  overflow: hidden;
  position: relative;
  display: flex;
  margin: 0 auto;
  align-items: center;
  border-radius: 0.2rem;
  margin-top: 0.1rem;

  .mailIcon {
    width: 20px;
    height: 20px;
    margin-left: 4px;
  }

  .container {
    overflow: hidden;
    white-space: nowrap;
    width: 100%;
    display: flex;
    align-items: center;
    height: 100%;
  }
}

.notice_content {
  width: 100%;
  height: 100%;
  padding: 0;
  font-size: 0.32rem;
}

@keyframes scroll-left {
  0% {
    transform: translateX(100%);
  }

  100% {
    transform: translateX(-100%);
  }
}

.notice_root .notice_icon {
  overflow: hidden;
  position: relative;
  display: flex;
  // width: 0.5rem;
  height: 0.43rem;
  margin-left: 0;
  margin-right: 2px;
}

/deep/ .van-tab {
  width: 2.3rem;
  border-bottom: 1px solid @bodercolor;
}

/deep/ .van-tabs--line .van-tabs__wrap {
  height: auto;
}

.nav_box {
  // width: 95%;
  background-color: @secondary-color;
  background-size: cover;
  // margin: 0 auto 0.2rem auto;
}

/deep/ .van-tabs__nav--line {
  padding-bottom: 0 !important;
}

/deep/ .van-tabs__line {
  bottom: 0 !important;
}

/deep/ .van-button--disabled {
  background-color: #999999;
  opacity: 10;
}

.submitCode {
  width: 95%;
  border-radius: .2rem;
  height: 1rem;
  font-size: .32rem;
}

/deep/ .van-button--primary {
  border: none;
}

/deep/ .van-button__text {
  background: none !important;
  color: #fff;
}

.adv {
  width: 96%;
  margin: 0.2rem auto 0 auto;
}

.adv img {
  width: 100%;
}

.service {
  position: fixed;
  width: 1rem;
  bottom: 2rem;
  right: 0.1rem;
  z-index: 2;
  background: white;
  border-radius: 50%;
}

#indexbr_box {
  position: fixed;
  width: 78px;
  bottom: 2rem;
  right: 20px;
  z-index: 1;

  img {
    margin-bottom: 5px;
  }
}

.telegram {
  position: relative;
  display: inline-block;
  width: 78px;
  padding-left: 6px;
  opacity: 1;

  // animation-name: scaleAnimation; // 动画名
  // animation-duration: 3s; // 动画时长
  // animation-iteration-count: infinite; // 永久动画
  // transition-timing-function: ease-in-out; // 动画过渡
  img {
    width: 100%;
    height: 100%;
  }

  .icon_box {
    position: absolute;
    right: -5px;
    top: -5px;
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;

    .close_icon {
      color: @textcolor1;
      font-size: 14px;
    }
  }
}

.invitation {
  width: 1.6rem;
  z-index: 1;
  // animation-name: scaleAnimation; // 动画名
  // animation-duration: 3s; // 动画时长
  // animation-iteration-count: infinite; // 永久动画
  // transition-timing-function: ease-in-out; // 动画过渡
  //box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19); // 元素阴影
}

@keyframes scaleAnimation {

  // 动画设置
  0% {
    transform: scale(0.2);
  }

  25% {
    transform: scale(0.5);
  }

  50% {
    transform: scale(0.8);
  }

  75% {
    transform: scale(1.08);
    transform: rotate(360deg);
  }
}

.download {
  position: fixed;
  width: 1.2rem;
  bottom: 1.6rem;
  right: 0.1rem;
  z-index: 1;
  border-radius: 50%;
  opacity: 1;

  img {
    width: 100%;
    height: 100%;
  }
}

.van-button__text {
  background: white;
}
</style>
